import React from "react";
import { ServiceRequest } from "../types";

type ServiceRequestContextType = {
  serviceRequest: ServiceRequest | null;
  setServiceRequest: (usina: ServiceRequest | null) => void;
};

const defaultValue: ServiceRequestContextType = {
  serviceRequest: null,
  setServiceRequest: () => {},
};

export const ServiceRequestContext = React.createContext(defaultValue);

export default function ServiceRequestContextProvider(props: {
  children: React.ReactNode;
}) {
  const [serviceRequest, setServiceRequest] =
    React.useState<ServiceRequest | null>(null);
  return (
    <ServiceRequestContext.Provider
      value={{
        serviceRequest,
        setServiceRequest,
      }}
    >
      {props.children}
    </ServiceRequestContext.Provider>
  );
}
